import axios from "../../axios-config";
import { showToast } from "../../helper/ShowToast";
import { maybeSyncWorkspaceOnce } from "./billing";
import { queryClient } from "../../queryClient";

export const startAuth = () => {
    return {
        type: 'AUTHSTART'
    };
}

export const authFail = () => {
    return {
        type: 'AUTHFAIL'
    }
}
export const authSuccess = () => {
    return {
        type: 'AUTHSUCCESS'
    }
}

export const signup = (data, navigate, toast, resetTurnstile) => {
    return async dispatch => {
        dispatch(startAuth())
        try {
            const response = await axios.post('/user/v1/registration', data)
            dispatch(authSuccess())
            showToast("success", response.data.message, {
                autoClose: 800,
                onClose: () => navigate('/verify-otp', { state: { email: response.data.data.email } }),
            });
        } catch (error) {
            dispatch(authFail())
            resetTurnstile?.()
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 500 || error.response.status === 401
                    || error.response.status === 403 || error.response.status === 429 || error.response.status === 503
                ) {
                    showToast('error', error.response.data.message)
                }
            }
            else {
                showToast('error', error.message)
            }
        }

    }
}

export const verifyAccount = (data, navigate, toast) => {
    return async dispatch => {
        dispatch(startAuth())
        try {
            const response = await axios.post('/user/v1/verify-account', data)
            dispatch(authSuccess())
            showToast("success", response.data.message, {
                autoClose: 800,
                onClose: () => navigate('/complete-registration', { state: { email: response.data.data.email } }),
            });
        } catch (error) {
            dispatch(authFail())
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 500 || error.response.status === 401
                    || error.response.status === 403 || error.response.status === 429 || error.response.status === 503
                ) {
                    showToast('error', error.response.data.message)
                }
            }
            else {
                showToast('error', error.message)
            }
        }

    }
}

export const resendOtp = (data, setLoadingResndOtp, onCooldown, resetTurnstile) => {
    return async () => {
        setLoadingResndOtp(true)
        try {
            const response = await axios.post('/user/v1/resend-otp', data)
            showToast('success', response.data.message)
            onCooldown?.(60)
            resetTurnstile?.()
        } catch (error) {
            resetTurnstile?.()
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 500 || error.response.status === 401
                    || error.response.status === 403 || error.response.status === 429 || error.response.status === 503
                ) {
                    showToast('error', error.response.data.message)
                    if (error.response.status === 429) {
                        onCooldown?.(error.response.data.retryAfterSec || 60)
                    }
                }
            }
            else {
                showToast('error', error.message)
            }
        } finally {
            setLoadingResndOtp(false)
        }

    }
}

export const completeRegistration = (data, navigate, toast) => {
    return async dispatch => {
        dispatch(startAuth());
        try {
            const response = await axios.post('/user/v1/complete-registration', data);
            dispatch(authSuccess());
            localStorage.setItem('authToken', response.data.token)
            let res = response.data.data
            showToast(
                "success",
                "Account created. Link your Spotify profile or enter UpNComer to get started.",
                {
                autoClose: 1200,
                onClose: () => navigate('/link-accounts', {
                    state: {
                        token: response.data.token,
                        user: res,
                    },
                })
            });

        } catch (error) {
            dispatch(authFail());
            if (error.response) {
                if ([400, 401, 403, 429, 500, 503].includes(error.response.status)) {
                    showToast('error', error.response.data.message)
                }
            } else {
                showToast('error', error.message)
            }
        }
    };
};

export const forgotPassword = (data, setShowEmailSection, setResetPasswordSection, toast, onCooldown, resetTurnstile) => {
    return async dispatch => {
        dispatch(startAuth())
        try {
            const response = await axios.post('/user/v1/forgot-password', data)
            toast.success(response.data.message, {
                position: "top-center",
                theme: "colored",
                hideProgressBar: true
            })
            setShowEmailSection(false);
            setResetPasswordSection(true);
            onCooldown?.(60);
            resetTurnstile?.();
            dispatch(authSuccess()) // just for loading false
        } catch (error) {
            dispatch(authFail())
            resetTurnstile?.()
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 500 || error.response.status === 401
                    || error.response.status === 403 || error.response.status === 429 || error.response.status === 503
                ) {
                    toast.error(error.response.data.message, {
                        position: "top-center",
                        theme: "colored",
                        hideProgressBar: true
                    })
                    if (error.response.status === 429) {
                        onCooldown?.(error.response.data.retryAfterSec || 60)
                    }
                }
            }
            else {
                toast.error(error.message, {
                    position: "top-center",
                    theme: "colored",
                    hideProgressBar: true
                })
            }
        }

    }
}

export const resetPassword = (data, navigate, toast) => {
    return async dispatch => {
        dispatch(startAuth())
        try {
            const response = await axios.post('/user/v1/reset-password', data)
            toast.success(response.data.message, {
                position: "top-center",
                theme: "colored",
                hideProgressBar: true
            })
            dispatch(authSuccess())
            const load = () => { navigate('/login') }
            setTimeout(load, 2000);
        } catch (error) {
            dispatch(authFail())
            if (error.response) {
                if (error.response.status === 400 || error.response.status === 500 || error.response.status === 401
                    || error.response.status === 403 || error.response.status === 429 || error.response.status === 503
                ) {
                    toast.error(error.response.data.message, {
                        position: "top-center",
                        theme: "colored",
                        hideProgressBar: true
                    })
                }
            }
            else {
                toast.error(error.message, {
                    position: "top-center",
                    theme: "colored",
                    hideProgressBar: true
                })
            }
        }

    }
}

export const loginAuth = (token, details, access = null) => {
    return {
        type: 'LOGIN',
        token: token,
        details: details,
        access: access,
    };
}

/** App sign-out: clear auth token, cached API data, and user-specific Redux state. */
export const logout = () => {
    return (dispatch) => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('workspaceSynced');
        queryClient.clear();
        dispatch({ type: 'LOGOUT' });
    };
};

export const setAccess = (access) => ({
    type: 'SET_ACCESS',
    access: access || null,
});

export const setAuthToken = (token) => ({
    type: 'SET_AUTH_TOKEN',
    token: token || '',
});

export const setUserDetails = (details) => ({
    type: 'SET_USER_DETAILS',
    details: details || {},
    token: localStorage.getItem('authToken') || '',
});

let accessContextRequest = null;

/** Hydrate access + user profile (survives page refresh when Redux auth is empty). */
export const fetchAccessContext = () => {
    return (dispatch) => {
        if (accessContextRequest) {
            return accessContextRequest;
        }

        accessContextRequest = (async () => {
            try {
                const authCode = "Bearer " + localStorage.getItem('authToken');
                if (!localStorage.getItem('authToken')) return null;

                const response = await axios.get('/user/v1/access-context', {
                    headers: { Authorization: authCode },
                });
                const data = response?.data?.data;
                if (!data) return null;

                const { user, credits, ...accessPayload } = data;
                dispatch(setAccess({ ...accessPayload, credits: credits ?? null }));
                if (user) {
                    dispatch(setUserDetails(user));
                }
                return data;
            } catch {
                return null;
            } finally {
                accessContextRequest = null;
            }
        })();

        return accessContextRequest;
    };
};

export const login = (data, navigate, toast) => {
    return async dispatch => {
        dispatch(startAuth());
        try {
            console.log("base url", process.env.REACT_APP_API_URL)
            const response = await axios.post('/user/v1/login', data);
            dispatch(authSuccess());
            let res = response.data.data
            let user = res?.user
            const isProfileComplete = res?.isProfileComplete
            const userData = {
                token: res?.token,
                assignedArtistSongstateId: user?.assignedArtistSongstateId,
                access: res?.access || null,
            };

            if (!isProfileComplete) {
                showToast("info", "Please complete your registration to continue.")
                setTimeout(() => {
                    navigate("/complete-registration", {
                        state: {
                            email: user.email,
                            firstName: user.firstName || "",
                            lastName: user.lastName || "",
                            userName: user.userName || "",
                            country: user.country || null,
                            userType: user.userType,
                            from: "email",
                        },
                    });
                }, 1500);
            }
            else {
                showToast('success', response.data.message || "Login successful")
                setTimeout(() => {
                    localStorage.setItem('authToken', res.token)
                    dispatch(loginAuth(userData.token, user, res?.access || null));
                    // TODO(legacy-migration): Phase 2 — remove maybeSyncWorkspaceOnce after backend login sync is removed.
                    dispatch(maybeSyncWorkspaceOnce());
                    navigate('/dashboard', { state: userData, replace: true });
                }, 1500);
            }
        } catch (error) {
            dispatch(authFail());
            if (error.response) {
                const { status, data: responseData } = error.response;
                if (status === 401 && responseData?.code === "ACCOUNT_NOT_VERIFIED") {
                    showToast("info", responseData.message || "Please verify your account to continue.");
                    navigate("/verify-otp", { state: { email: responseData.data?.email } });
                    return;
                }
                if ([400, 401, 403, 429, 500, 503].includes(status)) {
                    showToast('error', responseData.message)
                }
            } else {
                showToast('error', error.message)
            }
        }
    };
};




